import { TFunction } from "i18next";

import { PaymentProvider } from "../../../../../services/PaymentSystem";
import translationPath from "../constants/translationPath";

const formatFallbackLabel = (label: string) =>
	label.length > 0 ? label[0].toUpperCase() + label.slice(1) : label;

export function getPaymentProviderDisplayName(
	provider: PaymentProvider | null | undefined,
	t: TFunction,
): string {
	if (!provider) {
		return "";
	}

	const translationKey = `${translationPath}.providers.${provider}`;
	const translated = t(translationKey);

	if (translated !== translationKey) {
		return translated;
	}

	return formatFallbackLabel(provider);
}
